<script setup lang="ts">
import { useSpecialConditionNotification } from '@autobid/ui/composables/auction/useSpecialConditionNotification'

interface Props {
  active: boolean
  auctionId: number
  carId?: number
}

const props = defineProps<Props>()
const emits = defineEmits(['close'])

const { handleAccept, markAsInformed, isLoading, specialConditionAccepted }
  = useSpecialConditionNotification({
    auctionId: props.auctionId,
    carId: props.carId,
    successCallback: () => {
      handleClose()
    },
  })

function handleClose() {
  markAsInformed()
  emits('close')
}
</script>

<template>
  <CommonDialog :opened="active" @close="handleClose">
    <template #title>
      {{ $t('auction-special-condition.dialog-title') }}
    </template>
    <template #content>
      <div class="w-full">
        {{ $t('auction-special-condition.dialog-description') }}
      </div>
    </template>
    <template v-if="!specialConditionAccepted" #buttons>
      <div class="flex flex-wrap items-center justify-between gap-2">
        <ElementsButton
          size="small"
          :outline="true"
          color="primary"
          :disabled="isLoading"
          @click="handleClose"
        >
          {{ $t('close') }}
        </ElementsButton>

        <ElementsButton
          size="small"
          color="primary"
          :disabled="isLoading"
          @click="handleAccept"
        >
          {{
            isLoading
              ? $t('loading')
              : $t('auction-special-condition.dialog-accept-button')
          }}
        </ElementsButton>
      </div>
    </template>
  </CommonDialog>
</template>
